import clone from '@/lib/clone';
import { setDeep } from '@shared/utils/setDeep.js';

/**
 * Array Operations: add, modify, delete
 */
const applyChangesToStep = ({ step: originalStep, changeObject, valueKey = 'newValue' }) => {
  if (!changeObject) {
    return originalStep;
  }

  let step = clone(originalStep);
  for (let i = 0; i < changeObject?.changes?.length; ++i) {
    const change = changeObject?.changes[i];
    const rootKey = change?.type;
    const fullKey = [rootKey, change?.key].filter((n) => !!n).join('.');
    const isArray = !!change?.id;
    const value = change?.[valueKey];

    // since arguments get saved like 'shipments[0].lines[].sku', setDeep was setting nested keys and breaking them. I think this is the only place we're doing something like this, so I handled it here...
    if (rootKey === 'arguments' || rootKey === 'options.customArguments') {
      step = setDeep(step, rootKey, (args) => {
        const newArgs = { ...args };
        if (value === undefined) {
          delete newArgs[change?.key];
        } else {
          newArgs[change?.key] = value;
        }
        return newArgs;
      });
      continue;
    }

    if (!isArray) {
      step = setDeep(step, fullKey, value);
      continue;
    }

    const operation = change?.operation || 'modify';
    step = setDeep(step, rootKey, (arr = []) => {
      if (operation === 'modify') {
        return arr.map((n) => (n.id === change?.id ? value : n));
      }
      if (operation === 'delete') {
        return arr.filter((n) => n.id !== change?.id);
      }
      if (operation === 'add' && !arr.find((n) => n.id === change?.id)) {
        return [...arr, value];
      }
      return arr;
    });
  }

  return step;
};

export default applyChangesToStep;
